import { render } from "./ProfileMatch.vue?vue&type=template&id=658d3c77"
import script from "./ProfileMatch.vue?vue&type=script&lang=js"
export * from "./ProfileMatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__